export default {
  cancel: 'Cancel',
  confirm: 'Confirm',
} as const;
